module.exports = __webpack_public_path__ + "static/nginx.90ad15ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nginx.png
// module id = 409
// module chunks = 159014900043430